import { render, staticRenderFns } from "./checkout-form.vue?vue&type=template&id=8a60f236&scoped=true"
import script from "./checkout-form.vue?vue&type=script&lang=js"
export * from "./checkout-form.vue?vue&type=script&lang=js"
import style0 from "./checkout-form.vue?vue&type=style&index=0&id=8a60f236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a60f236",
  null
  
)

export default component.exports